import { Component, OnInit } from '@angular/core';
import {
  ColDef, GetContextMenuItemsParams,
  GetDataPath,
  GetRowIdFunc,
  GetRowIdParams,
  GridApi,
  GridReadyEvent, IDetailCellRendererParams,
  SendToClipboardParams, SetFilterValuesFuncParams
} from "ag-grid-community";
import {environment} from "../../../environments/environment";
import {HttpService} from "../../services/http.service";
import {SkuComponent} from "../cell/sku/sku.component";
import {AiCategoryCellComponent} from "../cell/ai-category-cell/ai-category-cell.component";
import {Router} from "@angular/router";
import {AiTreeProductComponent} from "../cell/ai-tree-product/ai-tree-product.component";
import {GridService} from "../../services/grid.service";
import {AiReportDialogComponent} from '../../components/dialog/ai-report-dialog/ai-report-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ToastService} from '../../services/toast.service';
import {AiReplaceDialogComponent} from '../../components/dialog/ai-replace-dialog/ai-replace-dialog.component';

@Component({
  selector: 'app-grid-ai-tree',
  templateUrl: './grid-ai-tree.component.html',
  styleUrls: ['./grid-ai-tree.component.scss']
})
export class GridAiTreeComponent implements OnInit {
  private gridApi!: GridApi;
  private productGridApi!: GridApi;

  public productDetail: any = '';
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public productsGridData: any = [];

  public groupDefaultExpanded = 1;
  public detailCellRendererParams: any = {
    detailGridOptions: {
      columnDefs: [
        // {
        //   field: 'number',
        //   headerName: '#',
        //   maxWidth: 70,
        //   pinned: 'left',
        // },
        {
          field: 'breadcrumbs',
          headerName: 'breadcrumbs',
          resizable: true,
          minWidth: 1000
        }
      ],
      defaultColDef: {
        flex: 1,
      },
      masterDetail: true,
      detailRowAutoHeight: true
    },
    getDetailRowData: (params: any) => {
      // params.successCallback(params.data.children);
      console.log('getDetailRowData', params);
      try {
        let i = 1;
        const jsonData = JSON.parse(params.data.steps_log).map((x: any) => {
          return {
            number: i++,
            step: x
          }
        });
        console.log('jsonData', jsonData);
        params.successCallback(jsonData);
      } catch (err) {
        params.successCallback([]);
      }
    }
  } as IDetailCellRendererParams;

  public rowData: any[] = [];
  public defaultColDefProducts: ColDef = {
    flex: 1,
    resizable: true
    // filter: true,
    // floatingFilter: true,
    // checkboxSelection: true,
    // editable: true
  };
  public readonly statusBar = {
    statusPanels: [
      { statusPanel: 'agSelectedRowCountComponent' }
    ],
  };
  public defaultColDef: ColDef = {
    flex: 1,
    filter: true,
    floatingFilter: true,
    // checkboxSelection: true,
    // editable: true
  };
  public autoGroupColumnDef: ColDef = {
    headerName: 'Categories',
    minWidth: 700,
    resizable: true,
    sortable: false,
    filter: 'agTextColumnFilter',
    // cellRenderer: AiCategoryCellComponent,
    // checkboxSelection: true,
    filterParams: {

    },
    flex: 1,
    cellRendererParams: {
      // suppressCount: true,
      // checkbox: true,
      innerRenderer: AiCategoryCellComponent
    },
  };
  public columnDefsProducts: ColDef[] = [
    {
      field: 'product_id',
      headerName: 'product_id',
      minWidth: 150,
      hide: false,
    },
    {
      field: 'sku',
      headerName: 'sku',
      checkboxSelection: true,
      headerCheckboxSelection: true,
      minWidth: 150,
      maxWidth: 180
    },
    {
      field: 'brand',
      headerName: 'brand',
      minWidth: 150,
      maxWidth: 150
    },
    {
      field: 'body',
      headerName: 'body',
      minWidth: 2000
    },
    {
      field: 'type',
      headerName: 'type',
      hide: true,
    },
  ];
  public columnDefs: ColDef[] = [
    // {
    //   valueGetter: "",
    //   dndSource: true,
    //   pinned: 'left',
    //   width: 70,
    // },
    {
      field: 'product_id',
      headerName: 'Products',
      resizable: true,
      cellRenderer: AiTreeProductComponent,
      width: 2000,
      minWidth: 2000,
      // filter: 'agTextColumnFilter',
      filter: false,
      // cellRenderer: (params: any) => {
      //   if (params.data && params.data.products) {
      //     return params.data?.products?.join(', ');
      //   } else {
      //     return '';
      //   }
      // },
    },
    {
      headerName: 'Products Counter',
      field: 'size',
      // filter: true,
      sortable: true,
      sort: 'desc',
      filter: 'agNumberColumnFilter',
      // aggFunc: 'sum',
      aggFunc: params => {
        let totalSize = 0;
        for (const child of params.rowNode.allLeafChildren) {
          const data = child.data.size;
          totalSize += +data;
        }
        // if (params.rowNode.key === 'Industrial') {
        //   console.log('312312312', totalSize, params);
        // }
        // let total = 0;
        // params.values.forEach(value => total += +value);
        // return total;
        return totalSize;
      },
      pinned: 'right',
      width: 170,
      // valueFormatter: (params) => {
      //   console.log('paramsparams', params);
      //   return params.value;
      // },
      // filter: 'agNumberColumnFilter'
    },
  ];
  public getRowId: GetRowIdFunc = (params: GetRowIdParams) => {
    return params.data.id;
  };
  public getDataPath: GetDataPath = (data: any) => {
    return data.structure;
  };

  public readonly sideBar = {
    toolPanels: [
      {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
        toolPanelParams: {
          suppressExpandAll: false,
          suppressFilterSearch: false
        }
      }
    ]
  };
  constructor(
    private router: Router,
    private httpService: HttpService,
    private gridService: GridService,
    private dialog: MatDialog,
    private toastService: ToastService,
  ) { }

  ngOnInit(): void {
    this.gridService.aiTreeGridEvent.asObservable().subscribe((res: any) => {
      if (res && res === 'rename' || res === 'remove') {
        this.productGridApi.showLoadingOverlay();
        this.httpService.get(environment.API_PATH + '/ai/getLearModelTree').subscribe(res => {
          this.rowData = res;
          this.topFilterIsActive = false;
          this.productGridApi.hideOverlay();
        });
      }
    });

    this.httpService.get(environment.API_PATH + '/ai/getLearModelTree').subscribe(res => {
      this.rowData = res;
      this.topFilterIsActive = false;
      this.productGridApi.hideOverlay();
    });

    this.gridService.aiTreeSelectProject.asObservable().subscribe(res => {
      if (res) {
        this.productDetail = res;
      }
    });
  }

  public parents: any[] = [];

  onDrop(event: any) {
    console.log('drop event', event);
    // const jsonData = event.dataTransfer.getData('application/json');
    // const eJsonRow = document.createElement('div');
    // eJsonRow.classList.add('json-row');
    // eJsonRow.innerText = jsonData;
    // const eJsonDisplay = document.querySelector('#eJsonDisplay')!;
    // eJsonDisplay.appendChild(eJsonRow);
    event.preventDefault();
  }

  onDragOver(event: any) {
    // console.log('dragSupported', event);
    const dragSupported = event.dataTransfer.length;
    if (dragSupported) {
      event.dataTransfer.dropEffect = 'move';
    }
    event.preventDefault();
  }
  private getParentsNode(node: any): any {
    if (node.key) {
      this.parents.unshift(node.key);
    }
    if (node.parent) {
      this.getParentsNode(node.parent);
    }
  }

  filterChanged(event: any) {
    const filterModel = this.gridApi?.getFilterModel();
    if (filterModel && filterModel['ag-Grid-AutoColumn']) {
      console.log('filterModel', filterModel['ag-Grid-AutoColumn'].filter);
      this.gridService.aiTreeChangeFilter.next(filterModel['ag-Grid-AutoColumn'].filter);
    } else {
      this.gridService.aiTreeChangeFilter.next('');
    }
  }

  treeSelectionChanged(event: any) {
    // console.log('event', event);
    const selectedRows: any = this.gridApi?.getSelectedNodes();
    // console.log('getSelectedNodes', selectedRows)
  }

  public selectedCategories: any = [];
  onRowClick(event: any): void {
    this.productDetailSelected = false;
    this.parents = [];
    const parent = event.node.parent.key;
    const currentElement = event.node.key;
    this.getParentsNode(event.node);
    this.gridService.aiTreeSelectLevel.next(this.parents.join(' > '));

    if (event.event.metaKey || event.event.ctrlKey) {
      if (this.selectedCategories.includes(this.parents.join(' > '))) {
        this.selectedCategories = this.selectedCategories.filter((item: any) => item !== this.parents.join(' > '));
      } else {
        this.selectedCategories.push(this.parents.join(' > '));
      }
    } else {
      this.selectedCategories = [this.parents.join(' > ')];
    }

    if (this.selectedCategories.length === 1) {
      this.httpService.post(environment.API_PATH + '/ai/getProductInfo', {
        levels: this.parents.join(' > ')
      }).subscribe(res => {
        this.productsGridData = res;
      });
    } else {
      this.httpService.post(environment.API_PATH + '/ai/getManyProductInfo', {
        levels: this.selectedCategories
      }).subscribe(res => {
        this.productsGridData = res;
      });
    }
  }
  sendToClipboard(params: SendToClipboardParams) {
    console.log('send to clipboard called with data:');
    console.log(params);
  }

  getContextMenuItems = (params: GetContextMenuItemsParams) => {
    return [
      {
        name: 'Open Shopify Page',
        disabled: false,
        icon: '<span class="ag-icon ag-icon-eye" unselectable="on" role="presentation"></span>',
        action: () => {
          window.open('https://blackhawksupply.com/products/' + params?.node?.data.handle, '_blank');
        }
      }
    ]
  }

  onGridReady(params: GridReadyEvent) {
    this.productGridApi = params.api;
    this.productGridApi.showLoadingOverlay();
  }

  public productDetailSelected: boolean = false;
  moveProducts() {
    const selectedProducts: any = this.productGridApi?.getSelectedRows().map((row: any) => row.product_id);
    // console.log('this.parents.join(\' > \')', this.parents.join(' > '));
    setTimeout(() => {
      const breadcrumbs = this.parents.join(' > ');
      const prompt = window.prompt('Move', breadcrumbs);
      if (prompt && prompt.length) {
        this.httpService.post(environment.API_PATH + '/ai/aiTreeProductActions', {
          // type: 'mega_rename',
          new_path: prompt,
          products: selectedProducts,
          // field: breadcrumbs.replace(/<[^>]+>/g, ''),
          levels: breadcrumbs
        }).subscribe(res => {
          // this.gridService.aiTreeGridEvent.next('rename');
        });
      }
    }, 100);
  }

  productsSelectionChanged(event: any) {
    const selectedRows: any = this.productGridApi?.getSelectedRows().length;
    this.productDetailSelected = !!selectedRows;
    // const selectedRows: any = this.productGridApi?.getSelectedRows();
    // console.log(selectedRows);
  }

  public topValue = 5;
  public topFilterIsActive: boolean = false;
  public getTopFilePending: boolean = false;
  public fullCompliance: boolean = false;

  public pendingStatsExport: boolean = false;
  public pendingTopAllExport: boolean = false;

  public topSliceValue = 0;
  public topEndSliceValue = 0;
  public tops: any = [];
  getTop() {
    this.getTopFilePending = true;
    this.productGridApi.showLoadingOverlay();
    this.httpService.post(environment.API_PATH + '/ai/getTopForTree', {
      top: Number(this.topValue) || 3,
      slice: Number(this.topSliceValue) || 0,
      endSlice: Number(this.topEndSliceValue) || 0,
      fullCompliance: this.fullCompliance
    }).subscribe((res: any) => {
      this.topFilterIsActive = true;
      this.rowData = res.tree;
      this.tops = res.tops;
      this.productGridApi.hideOverlay();
      this.getTopFilePending = false;
    });
  }

  exportTop() {
    if (confirm('Are you sure?')) {
      this.topFilterIsActive = false;
      this.httpService.post(environment.API_PATH + '/ai/exportTop', {
        top: Number(this.topValue),
        slice: Number(this.topSliceValue)
      }).subscribe((res: any) => {
        this.topFilterIsActive = true;
        this.toastService.success(`<a target="_blank" href="${res.filePath}">Click here</a> to download the file.`,'Export TOP', {
          disableTimeOut: true,
          enableHtml: true
        });
      });
    }
  }

  exportStats() {
    if (confirm('Are you sure?')) {
      this.pendingStatsExport = true;
      this.httpService.get(environment.API_PATH + '/ai/aiStats').subscribe((res: any) => {
        this.pendingStatsExport = false;
        this.toastService.success(`<a target="_blank" href="${res.filePath}">Click here</a> to download the file.`,'Export Stats', {
          disableTimeOut: true,
          enableHtml: true
        });
      });
    }
  }

  exportTopAll() {
    if (confirm('Are you sure?')) {
      this.pendingTopAllExport = true;
      this.httpService.post(environment.API_PATH + '/ai/exportTopAll', {}).subscribe((res: any) => {
        this.pendingTopAllExport = false;
        this.toastService.success(`<a target="_blank" href="${res.filePath}">Click here</a> to download the file.`,'Export Top All', {
          disableTimeOut: true,
          enableHtml: true
        });
      });
    }
  }


  showReplaceDialog() {
    this.dialog.open(AiReplaceDialogComponent, {
      width: '90%',
      maxWidth: '654px',
      disableClose: true,
    });
  }
  getGptLastUpdate() {
    this.dialog.open(AiReportDialogComponent, {
      width: '90%',
      maxWidth: '1024px',
      disableClose: true,
    });
  }
  back() {
    this.router.navigate(['grid/ai/fine-tuning']);
  }

  public pending: boolean = false;
  rebuild() {
    this.pending = true;
    this.productGridApi.showLoadingOverlay();
    this.httpService.get(environment.API_PATH + '/ai/clearTreeCache').subscribe(res2 => {
      this.httpService.get(environment.API_PATH + '/ai/getLearModelTree').subscribe(res => {
        this.rowData = res;
        this.topFilterIsActive = false;
        this.productGridApi.hideOverlay();
        this.pending = false;
      });
    });
  }

  protected readonly Object = Object;
}
